<template>
  <div class="soar-container flex justify-between items-center flex-col gap-y-2 pt-2 mb-3">
    <RouterLink to="/" class="banners w-full flex justify-between items-center h-[107px]" dir="ltr">
      <template v-if="themeStore.currentScheme == 'light'">
        <img src="@/assets/pngs/icalogo.png" alt="icalogo" class="w-80 lg:w-1/2 h-auto" />
        <img src="@/assets/pngs/uaelog.png" alt="uaelog" class="w-10 lg:w-20 h-auto" />
      </template>
      <template v-else>
        <img src="@/assets/pngs/icalogo-dark.png" alt="icalogo" class="w-80 lg:w-1/2 h-auto" />
        <img src="@/assets/pngs/uaelog-dark.png" alt="uaelog" class="w-10 lg:w-20 h-auto" />
      </template>
    </RouterLink>
    <div class="w-full hidden lg:block pt-4 text-[0.93rem]">
      <div class="w-full flex justify-between">
        <nav class="w-full flex gap-x-5 items-center text-center text-brand-black-secondary">
          <button @click="onMostVisitedClick">
            <i
              class="mt-1 ica-custom-fonts-quick-links text-xl text-primary/80 leading-[unset] tracking-[unset]"
            />
          </button>
          <router-link class="text-primary hover:text-primary hover:underline" to="/">
            <FontAwesomeIcon
              :icon="faHouseChimney"
              :class="{ 'fill-primary/80 text-primary/80': route.name == 'home' }"
              class="text-lg"
            />
          </router-link>
          <router-link
            :class="{
              'text-primary': matchedRoute.includes('/services/public')
            }"
            class="hover:text-primary hover:underline"
            to="/services/public"
          >
            {{ $t('visitorServices') }}
          </router-link>
          <router-link
            :class="{ 'text-primary': matchedRoute.includes('/services/golden-residency') }"
            class="hover:text-primary hover:underline"
            to="/services/golden-residency"
          >
            {{ $t('goldenServices') }}
          </router-link>
          <router-link
            :class="{ 'text-primary': matchedRoute.includes('/services/public-visa') }"
            class="hover:text-primary hover:underline"
            to="/services/public-visa"
          >
            {{ $t('publicVisaServices') }}
          </router-link>
          <HelpMenu />
          <UsermanualMenu />
        </nav>
        <div class="settings flex items-center gap-x-3 text-sm">
          <div id="google_translate_element" class="google-translate-hide"></div>
          <button class="hover:text-primary" @click="handleTranslate">
            <div class="w-full flex items-center gap-x-2">
              <i class="ica-custom-fonts-language text-primary-color text-xl text-primary-700" />
              <span class="text-primary">{{ $t('googleTranslate') }}</span>
            </div>
          </button>
          <button
            :key="i18n.locale"
            class="w-full flex items-center gap-x-2 border-x-2 border-primary px-2"
            @click="toggleLocale"
          >
            <faGlobeAsiaIcon class="w-4 fill-primary/80 hover:fill-primary" />
            <span v-if="i18n.locale.value == 'en'" class="text-primary">العربية</span>
            <span v-else class="text-primary">English</span>
          </button>

          <button v-if="showLoginButton" class="hover:underline" @click="onQuickSearchClick">
            <div class="w-full flex">
              <faMagnifyingGlassIcon class="w-4 fill-primary/80 hover:fill-primary" />
            </div>
          </button>
          <button
            v-if="showLoginButton"
            class="rounded-md bg-gray-200 hover:bg-gray-300 px-3 py-1.5"
            @click="loginHandle"
          >
            <div class="w-full flex gap-x-2">
              <faUserCircleIcon class="w-4 fill-primary/80 hover:fill-primary" />
              <span class="text-primary">{{ $t('login') }}</span>
            </div>
          </button>
          <button
            class="rounded-md bg-gray-200 hover:bg-gray-300 px-3 py-1.5"
            @click="onSettingsClick"
          >
            <div class="w-full flex gap-x-2">
              <faCogIcon class="w-4 fill-primary/80 hover:fill-primary" />
              <span class="text-primary">{{ $t('Settings') }}</span>
            </div>
          </button>
        </div>
      </div>
      <!-- breadcrumbs -->
      <div
        v-if="showBreadcrumbs"
        class="breadcrumbs w-full flex items-center gap-x-2 ltr:font-sans text-sm bg-brand-gray-300 px-1.5 py-2 mt-2"
      >
        <router-link to="/">{{ $t('Home') }}</router-link>
        <div class="text-sm">/</div>

        <RouterLink :to="i.to" :key="key" :disabled="isSameRoute(i.to)" v-for="(i, key) in crumbs">
          <div class="flex gap-x-2">
            <span>{{ i.label }}</span>
            <div class="text-sm">/</div>
          </div>
        </RouterLink>
      </div>
    </div>
    <!-- mobile header -->
    <div class="w-full lg:hidden flex justify-between items-center gap-x-4">
      <div class="w-full flex items-center gap-x-3">
        <MobilemenuTrigger class="block lg:hidden pt-2"></MobilemenuTrigger>
        <button @click="onMostVisitedClick">
          <i
            class="ica-custom-fonts-quick-links text-[1.3rem] text-primary/80 leading-[unset] tracking-[unset]"
          />
        </button>
        <RouterLink to="/">
          <faHouseIcon class="w-5 fill-primary/80 hover:fill-primary" />
        </RouterLink>
      </div>
      <div class="w-full flex justify-end items-center gap-x-3">
        <button @click="handleTranslate">
          <i class="ica-custom-fonts-language text-primary-color text-xl text-primary-700" />
        </button>
        <button :key="i18n.locale" class="flex gap-x-1" @click="toggleLocale">
          <faGlobeAsiaIcon class="w-5 fill-primary/80 hover:fill-primary" />
          <span v-if="i18n.locale.value == 'en'" class="text-primary">AR</span>
          <span v-else class="text-primary">EN</span>
        </button>
        <button @click="onQuickSearchClick">
          <faMagnifyingGlassIcon class="w-5 fill-primary/80 hover:fill-primary" />
        </button>
        <button @click="loginHandle">
          <faUserCircleIcon class="w-5 fill-primary/80 hover:fill-primary" />
        </button>
        <button @click="onSettingsClick">
          <faCogIcon class="w-5 fill-primary/80 hover:fill-primary" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import MobilemenuTrigger from '@/components/headers/mobile_menu/MenuTrigger.vue'
// import QuicksearchComponent from '@/assets/svgs/quick-search.svg?component'
import faCogIcon from '@/assets/icons/faCog.svg?component'
import faGlobeAsiaIcon from '@/assets/icons/faGlobeAsia.svg?component'
import faHouseIcon from '@/assets/icons/faHouse.svg?component'
import faMagnifyingGlassIcon from '@/assets/icons/faMagnifyingGlass.svg?component'
import faUserCircleIcon from '@/assets/icons/faUserCircle.svg?component'
import HelpMenu from '@/components/headers/shared/HelpMenu.vue'
import UsermanualMenu from '@/components/headers/shared/UsermanualMenu.vue'
import useLoadScript from '@/composables/useLoadScript'
import useStringFunctions from '@/composables/useStringFunctions'
import { useGlobalStore } from '@/stores/global'
import { faHouseChimney } from '@fortawesome/free-solid-svg-icons'
import { useCookies } from '@vueuse/integrations/useCookies'
import { computed, nextTick, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useThemeStore } from '@/stores/theme'

const i18n = useI18n()
const globalStore = useGlobalStore()
const themeStore = useThemeStore()
const route = useRoute()

const matchedRoute = computed(() => {
  return route.matched.map((m) => m.path)
})

const showLoginButton = computed(() =>
  [
    'home',
    'RegisterIndividuals',
    'forgetPassword',
    'EstablishmentChangeUsername',
    'RegisterEstablishments',
    'RegisterTypingCenters',
    'TypingcentersChangeUsername',
    'forgot-password',
    'EstablishmentInquiry',
    'FileValidity',
    'PublicServicesApplicationTracking',
    'PublicVisaApplicationTracking'
  ].includes(route.name)
)

const crumbs = computed(() => {
  const matchedRoutes = route.matched
  return matchedRoutes
    .filter((r) => r.meta.breadcrumb?.hidden != true)
    .map((routeItem) => {
      /**
       * dynamically set the breadcrumb path
       */
      if (routeItem.name == 'ServicesGrid') {
        const category = route.params.category

        return {
          label: useStringFunctions(category).kebabToTitle(),
          to: routeItem.path
        }
      }

      return {
        label: i18n.t(routeItem.meta?.breadcrumb?.label || routeItem.name),
        to: routeItem.path
      }
    })
})

const loginHandle = () => {
  const loginContainerDom = document.querySelector('.login-container')
  loginContainerDom && loginContainerDom.scrollIntoView({ behavior: 'smooth' })
}

// do not show if
const showBreadcrumbs = computed(() => {
  const inHome = route.name == 'home'

  const excludePaths = ['/individuals']

  return !inHome && excludePaths.includes(route.path)
})

const handleTranslate = () => {
  document.getElementsByClassName('goog-te-gadget-simple')[0].click()
}

const onMostVisitedClick = () => {
  globalStore.$patch({ topbarState: 'most-visited' })
}

const onQuickSearchClick = () => {
  globalStore.$patch({ topbarState: 'search' })
}

const onSettingsClick = () => {
  globalStore.$patch({ endbarState: true })
}

const onLocaleChange = async () => {
  await nextTick()
  const locale = i18n.locale.value
  globalStore.languageId = locale == 'ar' ? 1 : 2

  const cookies = useCookies(['locale'])
  cookies.set('i18n_redirected', locale)

  const html = document.querySelector('html')
  html.setAttribute('lang', locale)
  html.setAttribute('dir', locale == 'ar' ? 'rtl' : 'ltr')
}

const loadGoogleTranslateScript = () => {
  useLoadScript(
    '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit',
    'google-translate-script'
  )
  window.googleTranslateElementInit = null
  window.googleTranslateElementInit = () => {
    const currentLanguage = navigator.language.split('-')[0]
    new google.translate.TranslateElement(
      {
        pageLanguage: currentLanguage,
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE
      },
      'google_translate_element'
    )
  }
}
onMounted(() => {
  loadGoogleTranslateScript()
})

const toggleLocale = () => {
  if (i18n.locale.value == 'en') {
    i18n.locale.value = 'ar'
  } else {
    i18n.locale.value = 'en'
  }

  onLocaleChange()
}

const isSameRoute = (path) => {
  return route.path == path
}
</script>

<style lang="scss" scoped>
.google-translate-hide {
  width: 2px;
  height: 2px;
  opacity: 0;
  overflow: hidden;
}
</style>
